import { createSlice } from "@reduxjs/toolkit";

const AppThemeSlice = createSlice({
  name: "theme",
  initialState: {
    theme: [],
    loading: false,
    error: null,
    successMessage: null,
    errorMessage: null,
  },
  reducers: {
    // Get Theme
    fetchThemeRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
  fetchThemeSuccess: (state, action) => {
  state.loading = false;
  state.theme = action.payload; 
     state.successMessage = "Theme Get successfully";
},
    fetchThemeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
        state.successMessage = "Theme Fail to Get successfully";
    },

    // Create / Update Theme
    createThemeRequest: (state) => {
      state.loading = true;
      state.successMessage = null;
      state.errorMessage = null;
    },
    createThemeSuccess: (state, action) => {
      state.loading = false;
      state.theme = action.payload;
      state.successMessage = "Theme saved successfully";
    },
    createThemeFailure: (state, action) => {
      state.loading = false;
      state.errorMessage = action.payload;
    },

    // Reset messages
    clearThemeMessages: (state) => {
      state.successMessage = null;
      state.errorMessage = null;
    },
  },
});

export const {
  fetchThemeRequest,
  fetchThemeSuccess,
  fetchThemeFailure,
  createThemeRequest,
  createThemeSuccess,
  createThemeFailure,
  clearThemeMessages,
} = AppThemeSlice.actions;

export default AppThemeSlice.reducer;